import { isSsr } from './general';
export var redirectToSignIn = function () {
    if (!isSsr) {
        window.location.replace("/auth/view/signin?redirect=".concat(window.location.pathname));
    }
};
export var redirectToGuestOrderTracker = function () {
    if (!isSsr) {
        window.location.replace("/myaccount/guest-order-tracking");
    }
};
